function updateCartBubble(t){

const n=document.querySelector("#cart-icon-bubble");

if(!n)return;

const i=n.querySelector(".cart-count-bubble");

i&&i.remove();

const a=n.querySelector(".visually-hidden");

if(a&&a.remove(),t<=0)return;

const e=document.createElement("span");

e.className="visually-hidden";

e.textContent="Cart";

const c=document.createElement("div");

c.className="cart-count-bubble";

c.innerHTML=`
<span aria-hidden="true">${t}</span>
<span class="visually-hidden">${t} items</span>
`;

n.appendChild(e);

n.appendChild(c);

}

$(document)

.off("submit.shopifyAdd",'form[action="/cart/add"]')

.on("submit.shopifyAdd",'form[action="/cart/add"]',async function(t){

// =========================
// STOP REDIRECT
// =========================

t.preventDefault();

t.stopImmediatePropagation();

t.stopPropagation();

const n=$(this),

i=n.find('button[type="submit"]');

if(n.data("adding")) return false;

n.data("adding",!0);

i.prop("disabled",!0);

try{

// =========================
// FORM DATA
// =========================

const formData = new FormData(this);

const variantId = formData.get("id");

const gstRate = formData.get("properties[_gst_rate]") || 0;

// =========================
// GET CURRENT CART
// =========================

const cartResponse = await fetch('/cart.js');

const cart = await cartResponse.json();

// =========================
// CHECK PRODUCT EXISTS
// =========================

const existingItem = cart.items.find(item => {

return Number(item.variant_id) === Number(variantId);

});

let responseData = null;

// =========================
// UPDATE EXISTING PRODUCT
// =========================

if(existingItem){

await fetch('/cart/update.js',{

method:'POST',

headers:{
'Content-Type':'application/json'
},

body:JSON.stringify({

updates:{
[existingItem.key]: existingItem.quantity + 1
}

})

});

// =========================
// GET UPDATED CART
// =========================

const updatedCartResponse = await fetch('/cart.js');

const updatedCart = await updatedCartResponse.json();

responseData = updatedCart.items.find(item => {

return Number(item.variant_id) === Number(variantId);

});

}else{

// =========================
// ADD NEW PRODUCT
// =========================

const addResponse = await fetch('/cart/add.js',{

method:'POST',

body:new URLSearchParams(formData)

});

responseData = await addResponse.json();

}

// =========================
// UPDATE CART NOTIFICATION
// =========================

!function(t){

const n=Number(t.properties?._gst_rate||gstRate||0),

i=t.price/100,

a=t.quantity,

e=i*a,

c=e*n/100,

o=Math.round(e+c),

d=`

<div class="cart-notification-product__image global-media-settings">

<img
src="${t.image || t.featured_image?.url || ""}"
alt="${t.title || t.product_title}"
width="70"
height="70"
loading="lazy">

</div>

<div>

<h3 class="cart-notification-product__name h4">
${t.title || t.product_title}
</h3>

<dl>

<div class="product-option releaf-related-product-mini">

<p class="cart-item-quantity">
Qty: ${a}
</p>

</div>

<div class="product-option">

<p class="cart-item-price">
Rs. ${o}
</p>

</div>

</dl>

</div>

`;

$("#cart-notification-product").html(d)

}(responseData);

// =========================
// UPDATE CART COUNT
// =========================

$.getJSON("/cart.js",(function(t){

$("#cart-count").text(t.item_count);

updateCartBubble(t.item_count);

}));

// =========================
// OPEN NOTIFICATION
// =========================

$("#cart-notification")
.removeAttr("hidden")
.attr("aria-hidden","false")
.addClass("active");

$("body").addClass("overflow-hidden");

}catch(error){

console.log("There was an error adding the product to the cart.");

}

finally{

n.data("adding",!1);

i.prop("disabled",!1);

}

return false;

});

// =========================
// CLOSE NOTIFICATION
// =========================

$(document)

.off("click",".cart-notification__close")

.on("click",".cart-notification__close",(function(){

$("#cart-notification")
.removeClass("active")
.attr("aria-hidden","true");

$("body").removeClass("overflow-hidden");

}));

$(document)

.off("click",".cart-notification__links .link")

.on("click",".cart-notification__links .link",(function(){

$("#cart-notification")
.removeClass("active")
.attr("aria-hidden","true");

$("body").removeClass("overflow-hidden");

}));

// =========================
// UPDATE CART BUBBLE
// =========================

document.addEventListener("submit",(t=>{

const n=t.target;

if(n.action?.includes("/cart/add")){

setTimeout((()=>{

fetch("/cart.js")
.then((t=>t.json()))
.then((t=>updateCartBubble(t.item_count)))

}),1000);

}

}));